import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import StatusBadge from "../components/StatusBadge";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "awaiting_custody", label: "Awaiting custody" },
  { key: "awaiting_policy", label: "Awaiting policy" },
  { key: "awaiting_assurance", label: "Awaiting assurance" },
  { key: "approved", label: "Approved" },
  { key: "escalated", label: "Escalated" },
];

export default function RequestsPage() {
  const [requests, setRequests] = useState(null);
  const [filter, setFilter] = useState("all");
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.listRequests().then(setRequests).catch((e) => setErr(e.message));
  }, []);

  const filtered = !requests
    ? null
    : filter === "all"
    ? requests
    : requests.filter((r) => r.status === filter);

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="requests-page">
      <header className="mb-10">
        <p className="eyebrow">Reuse requests</p>
        <h1 className="font-display text-4xl md:text-5xl text-[var(--ink-heading)] mt-3 leading-tight">
          Every request, every receipt.
        </h1>
      </header>

      <div className="flex flex-wrap gap-2 mb-8" data-testid="filter-bar">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            data-testid={`filter-${f.key}`}
            onClick={() => setFilter(f.key)}
            className={`px-3 py-1.5 text-xs uppercase tracking-[0.14em] border transition-colors ${
              filter === f.key
                ? "bg-[var(--ink-heading)] text-[var(--bg-primary)] border-[var(--ink-heading)]"
                : "border-slate-300 text-[var(--ink-secondary)] hover:border-slate-900"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {err && <p className="text-sm text-red-700">{err}</p>}
      {filtered && (
        <table className="w-full text-sm border-t border-slate-200" data-testid="requests-table">
          <thead>
            <tr className="text-left text-[var(--ink-muted)]">
              <th className="py-3 pr-4 font-mono-ui text-[10.5px] uppercase tracking-[0.14em]">Ref</th>
              <th className="py-3 pr-4 font-mono-ui text-[10.5px] uppercase tracking-[0.14em]">Title</th>
              <th className="py-3 pr-4 font-mono-ui text-[10.5px] uppercase tracking-[0.14em]">Source system</th>
              <th className="py-3 pr-4 font-mono-ui text-[10.5px] uppercase tracking-[0.14em]">Risk</th>
              <th className="py-3 pr-4 font-mono-ui text-[10.5px] uppercase tracking-[0.14em]">Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-[var(--bg-secondary)]/40">
                <td className="py-4 pr-4 font-mono-ui text-xs">{r.id}</td>
                <td className="py-4 pr-4">
                  <Link to={`/request/${r.id}`} className="text-[var(--ink-heading)] hover:underline underline-offset-4">
                    {r.title}
                  </Link>
                </td>
                <td className="py-4 pr-4 text-[var(--ink-secondary)]">{r.source_system}</td>
                <td className="py-4 pr-4 text-[var(--ink-secondary)] capitalize">{r.risk_level}</td>
                <td className="py-4 pr-4"><StatusBadge status={r.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  );
}
